<template>
	<div>
	  <div v-html="news_content" v-if="news_content"></div>
	  <div v-else style="padding: 50px; text-align: center;">加载中...</div>
	</div>
  </template>
  
  <script>
	import request from '../common/request.js'
	export default {
	  data() {
		return {
		  news: {},
		  news_content: ""
		}
	  },
	  async created() {
		const newsId = this.$route.query.id
		if (!newsId) {
		  console.warn('缺少新闻ID参数')
		  return
		}
		await this.getNewsList(newsId)
	  },
	  methods: {
		async getNewsList(newsId) {
		  let res = await this.$Cloud.table(`lf_func_lefan_news`).get({ 
					page: 0, 
					pageSize: 100,
					sort_by: 'upload_time',
					order_by: 'desc'
				})
		  
		  console.log('获取新闻列表', res)
		  
		  const {code, data} = res
		  if (code == 200) {
			this.news = data.filter(item => item.is_check == 2)
			
			// 用 id 而不是 _id 来匹配
			const matchItem = this.news.find(item => item.id == newsId)
			
			if (matchItem) {
			  if (matchItem.news_content) {
				// 有内容就展示
				this.news_content = matchItem.news_content
			  } else if (matchItem.openurl) {
				// 没内容就跳转到外部链接
				window.location.href = matchItem.openurl
			  }
			}
		  }
		}
	  }
	}
  </script>
  
  <style>
  </style>
  